<template>
  <v-dialog :value="open" max-width="400" @click:outside="close">
    <template v-slot:activator="{ on }">
      <v-btn
        @click="$emit('update:open', true)"
        v-on="on"
        color="primary"
        block
        large
        depressed
        height="52"
        class="font--m-3"
      >
        상담 신청하기
      </v-btn>
    </template>

    <ValidationObserver v-slot="{ handleSubmit }" tag="div" class="width-100">
      <form @submit.prevent="handleSubmit(submit)">
        <v-card class="rounded-4">
          <v-card-title>
            <span class="font-weight-black">
              상담 신청
              <v-icon size="20" color="black">mdi-phone-incoming</v-icon>
            </span>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold">
            본 한도는 가심사 한도이므로 본 심사시 거절, 한도 조정 등이 발생할 수 있습니다.
          </v-card-subtitle>
          <v-card-text>
            <p class="color--nice-black font-weight-bold mb-1">고객님의 정보를 입력해주세요.</p>
            <CreditPayInput
              :inputValue.sync="form.name"
              :valid="{ name: '성함', rules: 'required' }"
              title="성함"
              placeholder="성함을 입력해 주세요"
            />

            <CreditPayInput
              :inputValue.sync="form.phone"
              :valid="{ name: '연락처', rules: 'required|phone' }"
              title="연락처"
              placeholder="연락처를 입력해 주세요"
              inputmode="numeric"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').substring(0, 11).replace(/^(\d{3})(\d{3,4})(\d{4})$/, '$1-$2-$3')"
            />
          </v-card-text>
          <v-card-actions class="pa-0">
            <v-btn
              block
              large
              height="52"
              color="primary"
              class="rounded-4 font--m-3"
              type="submit"
              :loading="loading"
              :disabled="loading"
            >
              확인
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  props: ['open', 'uuid'],
  components: {
    CreditPayInput: () => import('@/components/credit-pay/request/form/CreditPayInput.vue'),
  },

  data() {
    return {
      form: {
        name: '',
        phone: '',
      },
      loading: false,
    }
  },

  watch: {
    open(v) {
      this.dialog = v
    },
  },
  computed: {
    submitForm() {
      return {
        pre_approval_offer: this.uuid,
        name: this.form.name,
        phone: this.form.phone,
        referralCode: this.$cookies.get('referralCode') || '',
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:open', false)
    },
    async submit() {
      if (this.loading) {
        return
      }

      try {
        this.loading = true
        await defaultApi.postCrowdFundingRequest(this.submitForm)

        await this.$swal.basic.alert({
          html: '상담 신청이 완료됐습니다.<br/>1 영업일 이내에 상담사가 순차적으로 연락드릴 예정입니다.',
          confirmButtonText: '확인',
        })
        this.close()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v-btn[type='submit'] {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
</style>
